import {atom} from 'recoil';

export const passwordResetEmailState = atom<string>({
  key: 'passwordResetEmail',
  default: '',
});
